import {useEffect, useState} from 'react';
import useClaims from '../../Hooks/useClaims';

const ClaimGuard = ({ children, requiredClaim, anyOf, allOf, onUnauthorized = undefined }) => {
    const { hasClaim, hasAnyOf, hasAllOf, isLoading } = useClaims();
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        if(isLoading)
            return

        let isAuthorized = false;

        if (requiredClaim) {
            isAuthorized = hasClaim(requiredClaim);
        } else if (anyOf) {
            isAuthorized = hasAnyOf(...anyOf);
        } else if (allOf) {
            isAuthorized = hasAllOf(...allOf);
        }

        setIsAuthorized(isAuthorized);

        if(!isAuthorized && onUnauthorized)
        {
            onUnauthorized()
        }
    }, [isLoading, requiredClaim, anyOf, allOf, hasAllOf, hasAnyOf, hasClaim, onUnauthorized]);

    return isAuthorized ? children : null;
};

export default ClaimGuard;
